import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { getResolvedAttributes } from '@atlaskit/link-analytics/resolved-attributes';
import { useSmartCardState as useSmartLinkState } from '../../state/store';
import { LinkAnalyticsContext } from './LinkAnalyticsContext';
/**
 * Provides an analytics context to supply attributes to events based on a URL
 * and the link state in the store
 */
export const SmartLinkAnalyticsContext = props => {
  const {
    children,
    url,
    display
  } = props;
  const {
    details,
    status
  } = useSmartLinkState(url);
  const attributes = getResolvedAttributes({
    url
  }, details, status);
  return /*#__PURE__*/React.createElement(LinkAnalyticsContext, _extends({}, props, {
    display: display
  }), /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: {
      attributes
    }
  }, children));
};